import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "../../simple";
import SVG from "../../SVG";
import OptionTooltip from "../Tooltips/Options";

// import { formatDate } from "../../../helpers/formatter";

import "../../../styles/components/client-card.scss";

export default function ClientCard(props) {
  const {
    data,
    expanded,
    handleClick,
    handleEdit,
    handleRemove,
    canEdit,
    canRemove,
    handleClickUpgradeBtn,
    isSandbox
  } = props;
  const [popoverOpen, togglePopover] = useState(false);
  // const date = data.createdAt ? formatDate(data.createdAt) : "";
  const edit = () => {
    togglePopover(!popoverOpen);
    handleEdit(data);
  };
  const remove = () => {
    togglePopover(!popoverOpen);
    handleRemove(data);
  };

  const clientActions = [];

  if (canEdit) {
    clientActions.push({
      label: "Edit",
      callback: edit
    });
  }

  if (canRemove) {
    clientActions.push({
      label: "Remove",
      className: "danger",
      callback: remove
    });
  }

  return (
    <a
      href="/audiences"
      className={`client-card ${expanded ? "expanded" : ""} ${
        isSandbox ? "sandbox" : ""
      }`}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        handleClick(data.id);
      }}
    >
      <div className="client-card-name-container">
        <div>
          <div className="client-card-name">{data.name || ""}</div>
          <p>
            {data.sandbox
              ? "A Sandbox account where 5 monthly test activities are connected for free"
              : `Plan: ${data.plan}`}
          </p>
        </div>

        {data.sandbox || data.plan === "Subscription" ? null : (
          <Button
            className="btn-upgrade"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleClickUpgradeBtn();
            }}
          >
            Upgrade
          </Button>
        )}
      </div>
      {/* <div style={{marginTop: 'auto', width: '100%'}}> */}
      <div className="mt-auto w-100">
        <div className="client-card-description-container">
          <div className="client-card-info-item">
            <SVG.ClientActivations width={24} height={24} />
            <span>{data.statistics.activations} Activations</span>
          </div>
          <div className="client-card-info-item">
            <SVG.ClientUpload width={24} height={24} />
            <span>{data.statistics.uploads} Uploads</span>
          </div>
        </div>
        <div className="client-card-bottom">
          <p className="client-card-bottom-text">Click to see all actitivies</p>
          {!data.sandbox && (canEdit || canRemove) ? (
            <>
              <Button
                className="client-card-settings"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  togglePopover(!popoverOpen);
                }}
                id={`Card-${data.id}`}
              >
                <SVG.Dots className="dots" />
              </Button>
              <OptionTooltip
                tooltipOptions={{
                  placement: "bottom",
                  isOpen: popoverOpen,
                  target: `Card-${data.id}`,
                  toggle: () => togglePopover(!popoverOpen),
                  trigger: "legacy",
                  fade: true
                }}
                actions={clientActions}
              />
            </>
          ) : null}
        </div>
      </div>
    </a>
  );
}

ClientCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    createdBy: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
    sandbox: PropTypes.bool,
    plan: PropTypes.string,
    statistics: PropTypes.shape({
      activations: PropTypes.number,
      uploads: PropTypes.number
    })
  }).isRequired,
  expanded: PropTypes.bool,
  handleClick: PropTypes.func,
  handleEdit: PropTypes.func,
  handleRemove: PropTypes.func,
  canEdit: PropTypes.bool,
  canRemove: PropTypes.bool,
  isSandbox: PropTypes.bool.isRequired,
  handleClickUpgradeBtn: PropTypes.func.isRequired
};

ClientCard.defaultProps = {
  expanded: false,
  handleClick: () => null,
  handleEdit: () => null,
  handleRemove: () => null,
  canEdit: false,
  canRemove: false
};
